import React, { useState } from "react";
import { PageTitle } from "../components/PageHeader";

const Row = ({ label, desc }) => (
  <tr>
    <td className="border px-2 py-1 font-medium text-slate-700 whitespace-nowrap">{label}</td>
    <td className="border px-2 py-1 text-slate-600">{desc}</td>
  </tr>
);

const sections = [
  {
    id: "notificaciones",
    title: "Notificaciones",
    content: (
      <div className="space-y-2 text-sm text-slate-700">
        <p>Pantalla de inicio. Muestra avisos y comunicados del campus.</p>
      </div>
    ),
  },
  {
    id: "pagos",
    title: "Pagos",
    content: (
      <div className="space-y-3 text-sm text-slate-700">
        <p>Registro y consulta de pagos de cuatrimestre por alumno.</p>
        <div className="bg-slate-50 border border-slate-200 rounded p-3">
          <p className="font-semibold mb-1">Operaciones disponibles:</p>
          <ul className="list-disc list-inside space-y-0.5 text-slate-600">
            <li>Buscar alumno y registrar pago (efectivo, transferencia, en línea)</li>
            <li>Adjuntar comprobante de transferencia</li>
            <li>Ver historial de pagos por alumno</li>
            <li>Descargar evidencia de pago</li>
            <li>Actualizar datos de un pago existente</li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    id: "efectivo",
    title: "Entrega de Efectivo",
    content: (
      <div className="space-y-3 text-sm text-slate-700">
        <p>Registra la entrega de efectivo de caja. Requiere un comprobante adjunto.</p>
        <div className="bg-slate-50 border border-slate-200 rounded p-3">
          <table className="text-xs w-full border-collapse">
            <tbody>
              <Row label="Importe" desc="Monto del efectivo entregado" />
              <Row label="Archivo" desc="Comprobante en PDF, XLS o XLSX (máx. 3 MB)" />
            </tbody>
          </table>
        </div>
        <ul className="list-disc list-inside space-y-1 text-slate-600">
          <li>Un registro puede cancelarse desde el listado mientras esté en estatus <em>Pendiente</em>.</li>
          <li>El archivo adjunto puede descargarse desde el listado.</li>
        </ul>
      </div>
    ),
  },
  {
    id: "egreso",
    title: "Egreso",
    content: (
      <div className="space-y-3 text-sm text-slate-700">
        <p>Registra salidas de dinero (gastos operativos, proveedores, etc.).</p>
        <div className="bg-slate-50 border border-slate-200 rounded p-3">
          <table className="text-xs w-full border-collapse">
            <tbody>
              <Row label="Importe" desc="Monto del egreso" />
              <Row label="Concepto" desc="Descripción del gasto" />
              <Row label="Segmento" desc="Área o categoría del gasto" />
              <Row label="Tipo" desc="Clasificación del egreso" />
              <Row label="Forma de pago" desc="Efectivo, Tarjeta, Depósito o Transferencia" />
            </tbody>
          </table>
        </div>
        <p>Los registros pueden cancelarse desde el listado.</p>
      </div>
    ),
  },
  {
    id: "solicitudes",
    title: "Solicitudes Ingreso/Egreso",
    content: (
      <div className="space-y-2 text-sm text-slate-700">
        <p>Historial de solicitudes de ingreso y egreso. Permite consultar y cancelar registros.</p>
      </div>
    ),
  },
  {
    id: "validar",
    title: "Validar Pagos",
    content: (
      <div className="space-y-3 text-sm text-slate-700">
        <p>Lista los pagos por transferencia o depósito que requieren validación del comprobante.</p>
        <div className="bg-slate-50 border border-slate-200 rounded p-3">
          <p className="font-semibold mb-1">Pestañas:</p>
          <ul className="list-disc list-inside space-y-0.5 text-slate-600">
            <li><strong>Pendiente</strong> — comprobantes sin revisar</li>
            <li><strong>Aprobado</strong> — pagos validados</li>
            <li><strong>Declinado</strong> — comprobantes rechazados</li>
            <li><strong>Todos</strong> — vista completa</li>
          </ul>
        </div>
        <ul className="list-disc list-inside space-y-1 text-slate-600">
          <li>Filtro por año y búsqueda por nombre o código de alumno.</li>
          <li>Botón para descargar el comprobante adjunto.</li>
          <li>Al aprobar, el pago queda registrado. Al declinar, el alumno debe reenviar el comprobante.</li>
        </ul>
      </div>
    ),
  },
  {
    id: "actividad",
    title: "Actividad",
    content: (
      <div className="space-y-2 text-sm text-slate-700">
        <p>Bitácora de acciones realizadas en el sistema: altas, ediciones, pagos, egresos, cargas masivas y más.</p>
        <div className="bg-slate-50 border border-slate-200 rounded p-3">
          <p className="font-semibold mb-1">Datos registrados por evento:</p>
          <ul className="list-disc list-inside text-slate-600 space-y-0.5">
            <li>Descripción de la acción</li>
            <li>Módulo afectado</li>
            <li>Usuario que realizó la acción</li>
            <li>Fecha y hora</li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    id: "reporte",
    title: "Reporte de Pagos",
    content: (
      <div className="space-y-3 text-sm text-slate-700">
        <p>Genera un reporte de pagos en un rango de fechas con totales desglosados por forma de pago.</p>
        <div className="bg-slate-50 border border-slate-200 rounded p-3">
          <p className="font-semibold mb-1">Filtros:</p>
          <ul className="list-disc list-inside space-y-0.5 text-slate-600">
            <li><strong>Fecha inicio / Fecha fin</strong> — rango del reporte</li>
            <li><strong>Medio de pago</strong> — Efectivo, Transferencia, En Línea, o Todos</li>
          </ul>
        </div>
        <ul className="list-disc list-inside space-y-1 text-slate-600">
          <li>Muestra totales: general, transferencia, efectivo y en línea.</li>
          <li><em>Descargar Excel</em> exporta el reporte completo en CSV.</li>
          <li><em>Obtener deudores</em> muestra alumnos con adeudos agrupados por cuatrimestre.</li>
        </ul>
      </div>
    ),
  },
  {
    id: "admin-carreras",
    title: "Admin › Carreras",
    content: (
      <div className="space-y-3 text-sm text-slate-700">
        <p>Catálogo de carreras del campus. Permite agregar, editar y eliminar carreras.</p>
        <div className="bg-slate-50 border border-slate-200 rounded p-3">
          <table className="text-xs w-full border-collapse">
            <tbody>
              <Row label="Clave" desc="Identificador corto único (ej. ING-SIS). Se usa al cargar alumnos masivamente." />
              <Row label="Nombre" desc="Nombre completo de la carrera" />
              <Row label="Descripción" desc="Información adicional (opcional)" />
            </tbody>
          </table>
        </div>
      </div>
    ),
  },
  {
    id: "admin-personal",
    title: "Admin › Personal",
    content: (
      <div className="space-y-3 text-sm text-slate-700">
        <p>Alta y edición de usuarios del campus.</p>
        <div className="bg-slate-50 border border-slate-200 rounded p-3">
          <table className="text-xs w-full border-collapse">
            <tbody>
              <Row label="Nombre completo" desc="Nombre del usuario" />
              <Row label="CURP" desc="Clave Única de Registro de Población" />
              <Row label="Teléfono" desc="Número de contacto (opcional)" />
              <Row label="Email" desc="Correo electrónico (opcional)" />
              <Row label="Puesto" desc="Puesto del usuario dentro del campus" />
              <Row label="Contraseña" desc="Contraseña de acceso al sistema" />
              <Row label="Tipo de usuario" desc="Rol que define qué puede hacer en el sistema" />
            </tbody>
          </table>
        </div>
      </div>
    ),
  },
  {
    id: "admin-estudiantes",
    title: "Admin › Estudiantes + Carga Masiva",
    content: (
      <div className="space-y-3 text-sm text-slate-700">
        <p>Catálogo de alumnos. Permite registrar alumnos individualmente o en lote mediante un archivo Excel.</p>

        <p className="font-semibold">Carga masiva — pasos:</p>
        <ol className="list-decimal list-inside space-y-1 text-slate-600">
          <li>Descarga la plantilla con el botón <em>"Descargar plantilla"</em>.</li>
          <li>Llena el archivo. Las columnas con * son obligatorias.</li>
          <li>Sube el archivo y presiona <em>"Previsualizar"</em>.</li>
          <li>Revisa la tabla verde (válidos) y roja (con errores).</li>
          <li>Si hay errores, descarga el CSV de errores, corrígelos y vuelve a subir.</li>
          <li>Confirma con <em>"Confirmar y guardar"</em>.</li>
        </ol>

        <div className="bg-slate-50 border border-slate-200 rounded p-3">
          <table className="text-xs w-full border-collapse">
            <thead>
              <tr className="bg-slate-200">
                <th className="border px-2 py-1 text-left">Columna</th>
                <th className="border px-2 py-1 text-left">Obligatoria</th>
                <th className="border px-2 py-1 text-left">Detalle</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["Nombre", "Sí", "Nombre completo del alumno"],
                ["CURP", "Sí", "18 caracteres, formato oficial mexicano"],
                ["Email", "No", "Puede quedar vacío"],
                ["Teléfono", "No", "Número de contacto"],
                ["Clave Carrera", "Sí", "Clave corta de la carrera (ej. ING-SIS). Ver chips en pantalla"],
                ["Fecha Inicio", "Sí", "Formato YYYY-MM-DD (ej. 2024-01-15)"],
                ["Fecha Fin", "Sí", "Formato YYYY-MM-DD (ej. 2027-06-30)"],
                ["Matrícula", "No", "Código o matrícula del alumno"],
              ].map(([col, req, desc]) => (
                <tr key={col}>
                  <td className="border px-2 py-1 font-mono">{col}</td>
                  <td className="border px-2 py-1">{req}</td>
                  <td className="border px-2 py-1 text-slate-600">{desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded p-3 text-xs text-amber-700">
          <strong>Clave de carrera:</strong> usa la clave corta exacta, no el nombre de la carrera.
          Las claves disponibles aparecen como chips en pantalla antes de subir el archivo.
        </div>

        <p className="text-xs text-slate-500">
          Máx. 500 alumnos por archivo · máx. 2 MB · formatos .xlsx / .xls
        </p>
      </div>
    ),
  },
];

const Help = () => {
  const [open, setOpen] = useState(null);
  const toggle = (id) => setOpen(open === id ? null : id);

  return (
    <div className="flex-1 max-w-3xl">
      <PageTitle>Ayuda</PageTitle>
      <p className="text-sm text-slate-500 mb-6">Consulta cómo funciona cada sección del sistema.</p>

      <div className="space-y-2">
        {sections.map((s) => (
          <div
            key={s.id}
            style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}
          >
            <button
              onClick={() => toggle(s.id)}
              style={{
                width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '11px 16px', textAlign: 'left', border: 'none', cursor: 'pointer',
                backgroundColor: open === s.id ? '#111827' : '#f8fafc',
                transition: 'background-color 0.15s',
              }}
              onMouseEnter={e => { if (open !== s.id) e.currentTarget.style.backgroundColor = '#f1f5f9'; }}
              onMouseLeave={e => { if (open !== s.id) e.currentTarget.style.backgroundColor = '#f8fafc'; }}
            >
              <span style={{
                fontWeight: 600, fontSize: '0.82rem',
                color: open === s.id ? '#f9fafb' : '#374151',
                letterSpacing: '0.01em',
              }}>
                {s.title}
              </span>
              <span style={{
                color: open === s.id ? '#fca5a5' : '#9ca3af',
                fontSize: '18px', lineHeight: 1, marginLeft: '16px', flexShrink: 0, fontWeight: 300,
              }}>
                {open === s.id ? "−" : "+"}
              </span>
            </button>
            {open === s.id && (
              <div style={{ padding: '16px', borderTop: '2px solid #dc2626', backgroundColor: '#fff' }}>
                {s.content}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Help;
